import InfoIconPlaceholder from 'Components/people/components/InfoIconPlaceholder';
import React from 'react';
import PeopleIcon from '../assets/svgIcons/PeopleIcon';

const TooltipMessage = function TooltipMessage() {
  const proTip = (
    <span className="proTipText">
      <span className="weight-900">Pro tip:</span>
      Access your buyer groups by clicking on the
    </span>
  );
  const peopleTab = (
    <span className="peopleTabText">
      <span className="weight-900">People</span>
      tab in the left navigation bar
    </span>
  );
  return (
    <div className="toaster-content">
      <div className="info">
        <InfoIconPlaceholder />
        <span className="span-label">{proTip}</span>
      </div>
      <div className="people">
        <PeopleIcon />
        <span className="span-label">{peopleTab}</span>
      </div>
    </div>
  );
};

export default TooltipMessage;
